var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 16.0001H3C1.89543 16.0001 1 15.1047 1 14.0001V6.92002C1 6.33612 1.25513 5.78144 1.69842 5.40148L6.6984 1.11576C7.4474 0.473782 8.5526 0.473782 9.3016 1.11576L14.3016 5.40148C14.7449 5.78144 15 6.33612 15 6.92002V14.0001C15 15.1047 14.1046 16.0001 13 16.0001H11M5 16.0001V10.0001C5 9.44782 5.44772 9.00012 6 9.00012H10C10.5523 9.00012 11 9.44782 11 10.0001V16.0001M5 16.0001H11",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveHome);
export default __webpack_public_path__ + "static/media/active_home.56e68af34d5829a894a30359f113fb8f.svg";
export { ForwardRef as ReactComponent };